"use strict";

module.exports = Object.freeze({
  COMPLIANT: 'COMPLIANT',
  CORRECTED_ON_SITE: 'CORRECTED_ON_SITE',
  NA: 'NA',
  NOT_COMPLIANT: 'NOT_COMPLIANT',
  NOT_OBSERVED: 'NOT_OBSERVED'
});